module.exports = __webpack_public_path__ + "media/1.2eaeb36a.wav";